import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const FolderFilledIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8z"
      fill="currentColor"
    />
  </svg>
);

FolderFilledIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(FolderFilledIcon);
